export { default } from './image-3'
